import * as languageActions from "./language.actions";
import { getInitialLanguage } from "../../helper/language";

export const languageFeatureKey = "languageInfo";

const initialState = {
    selectedLanguage: getInitialLanguage(),
    errorMsg: ""
};

export const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case languageActions.CHANGE_LANGUAGE_SUCCESS:
            return {
                ...state,
                selectedLanguage: payload
            }

        case languageActions.CHANGE_LANGUAGE_FAILURE:
            return {
                ...state,
                errorMsg: payload
            }

        default: return state;
    }
};